var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-row",staticStyle:{"gap":"0.25rem"}},[_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_setup.props.checked},on:{"input":_setup.onChange}}),_c('span',{staticClass:"slider round"})]),_vm._v("\n  "+_vm._s(_setup.props.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }